const hopId = '__hop_id';

export const addHopIdToSessionStorage = (userId: number) => {
  sessionStorage.setItem(hopId, `${new Date().getTime()}_${userId}`);
};

export const addHopIdToHeader = (): Record<string, string> => {
  const tabHopId = window.sessionStorage.getItem(hopId);

  return tabHopId == null ? {} : { 'X-Hop-Id': tabHopId };
};

export const getHopId = () => {
  return window.sessionStorage.getItem(hopId);
};

export const safelyParseJSON = (jsonString) => {
  try {
    const parsedData = JSON.parse(jsonString);

    return parsedData; // Return the parsed object if successful
  } catch (error) {
    return null; // Return null or a default value in case of error
  }
};
